/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:fb7aa43e-b6a3-4603-9b6f-6c681aaaa8bb",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_rrLRypKYm",
    "aws_user_pools_web_client_id": "5j8ebpe038nncf2qev9mk2itti",
    "oauth": {
        "domain": "implicitweb0845284a-0845284a-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://implicit.io/home/,https://v2.implicit.io/home/,http://localhost:8080/home/",
        "redirectSignOut": "https://implicit.io/,https://v2.implicit.io/,http://localhost:8080/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS"
};


export default awsmobile;
